<template>
  <v-container class="container text-center">
    <v-row class="m-0 p-0">
      <v-col cols="12" class="padding0">
        Dial to
      </v-col>
      <div class="div-btn-close">
        <v-btn
          fab
          small
          color="transparent"
          class="btn-close"
          @click="clearDialIsOpenPanel"
        >
          <v-icon small> fa-times </v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row class="m-b-10">
      <v-col cols="12">
        <dial-number></dial-number>
      </v-col>
    </v-row>
    <v-row class="m-b-10">
      <v-col cols="12" class="padding0">
        <dial-pad></dial-pad>
      </v-col>
    </v-row>
    <v-row class="m-t-20">
      <v-col cols="12" class="padding0">
        <v-btn
          class="m-auto"
          color="success"
          :disabled="!dialPhoneNumber"
          @click="onClickCall"
        >
          <v-icon small color="white"> fa-phone </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DialNumber from './components/dial_number'
import DialPad from './components/dial_pad'

export default {
  name: 'StateDial',
  components: {
    DialNumber,
    DialPad
  },
  computed: {
    ...mapGetters('call', ['dialPhoneNumber'])
  },
  methods: {
    ...mapActions('call', [
      'setDialTo',
      'setDialIsCalling',
      'clearDialIsShowNumPads',
      'clearDialIsOpenPanel'
    ]),
    onClickCall() {
      this.setDialTo(this.dialPhoneNumber)
      this.clearDialIsShowNumPads()
      this.setDialIsCalling(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: white;
  position: absolute;
  z-index: 99;
  top: 4px;
  right: 5px;
  width: 250px;
  border-radius: 4px;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.div-btn-close {
  position: absolute;
  top: 0;
  right: 0;
}
.btn-close {
  width: 35px;
  height: 35px;
  box-shadow: none;
  border-radius: 50%;
}
</style>
